export default __webpack_public_path__ + "static/media/interviewhubplainlogo.af4f3234.jpg";